<template>
  <div
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    style="min-width: 250px;"
  >
    <label v-show="!question.is_list && fieldType.text !== null">
      <span v-html="fieldType.text"></span>
      <v-icon
        v-if="fieldType.required"
        size="10"
        color="red"
        style="vertical-align:middle;padding-left: 10px;"
      >
        mdi-asterisk
      </v-icon>
    </label>
    <div class="input-group">
      <div>
        <v-layout
          row
          wrap
          style="margin-top: 15px"
          v-bind:style="(answer.status === 'follow up' || highlightNoAnswer) ? 'background:#ffffcc;' : ''"
        >
          <v-flex
            xs4
            style="text-align:center;padding-right: 5px;"
          >
            <v-autocomplete
              ref="monthInput"
              v-model="value.month"
              v-bind:background-color="(answer.status === 'follow up' || highlightNoAnswer) ? '#ffffcc' : 'white'"
              :items="month_items"
              :rules="((value.day) && !value.month) ? [v => (!!v) || 'Month Required'] : []"
              :disabled="readonly"
              label="Month"
              auto-select-first="true"
              @blur="validateDate"
            >
              <v-icon
                v-if="answer.status"
                slot="prepend"
              >
                {{ statusIconClass }}
              </v-icon>
            </v-autocomplete>
          </v-flex>
          <v-flex
            xs4
            style="text-align:center;padding-right: 5px;"
          >
            <v-autocomplete
              ref="dayInput"
              v-model="value.day"
              v-bind:background-color="(answer.status === 'follow up' || highlightNoAnswer) ? '#ffffcc' : 'white'"
              :items="day_items"
              :disabled="readonly"
              label="Day"
              auto-select-first="true"
              @blur="validateDate"
            />
          </v-flex>
          <v-flex
            xs4
            style="text-align:center;"
          >
            <v-autocomplete
              ref="yearInput"
              v-model="value.year"
              v-bind:background-color="(answer.status === 'follow up' || highlightNoAnswer) ? '#ffffcc' : 'white'"
              :rules="(isRequired || ((value.month || value.year) && !value.year)) ? [v => (!!v) || 'Year Required'] : []"
              :items="year_items"
              :disabled="readonly"
              label="Year"
              auto-select-first="true"
              @blur="validateDate"
            />
          </v-flex>
          <div
            v-if="!valid"
            style="color: red;padding: 3px;text-align:center;font-size: 12px;"
          >
            <v-icon
              size="14"
              color="red"
            >
              warning
            </v-icon>
            Invalid Date - Please complete the date to save
          </div>
        </v-layout>
      </div>
      <slot></slot>
    </div>
    <TryAgain
      v-if="failed"
      :message="'Save'"
      @try="save"
    />
  </div>
</template>

<script>
import answerMixin from './answermixin'
import TryAgain from './TryAgain'
import moment from 'moment'

export default {
  name: 'HDateAnswer',
  mixins: [answerMixin],
  props: [ 'readonly' ],
  components: { TryAgain },
  data () {
    return {
      failed: false,
      menu: false,
      value: {
        year: null,
        month: null,
        day: null
      },
      savedValue: {
        year: null,
        month: null,
        day: null
      },
      valid: true,
      validationError: ""
    }
  },
  beforeMount () {
    this.value = {
      year: this.answer.year || null,
      month: this.answer.month || null,
      day: this.answer.day || null
    }
    this.savedValue = JSON.parse(JSON.stringify(this.value))
  },
  methods: {
    focus () {
      this.savedValue = JSON.parse(JSON.stringify(this.value))
    },
    validateDate () {
      if (this.value.day) {
        if (this.value.month && this.value.year) {
          if (this.value.day > this.max_days_in_month) {
            this.value.day = this.max_days_in_month
          }
          this.valid = true
        } else {
          this.valid = false
        }
      } else if (this.value.month) {
        if (this.value.year) {
          this.valid = true
        } else {
          this.valid = false
        }
      } else if (this.value.year) {
        this.valid = true
      } else {
        if (this.value.year !== this.savedValue.year) {
          this.valid = true
        }
      }
      if (this.valid)
        this.save()
    },
  },
  computed: {
    valueChanged () {
      return (
        this.value.year !== this.savedValue.year ||
        this.value.month !== this.savedValue.month ||
        this.value.day !== this.savedValue.day
      )
    },
    year_items () {
      var time = new Date()
      var date = 1900
      var dates = [{text: '', value: null}]

      do {
        date++
        dates.push(date)
      }
      while (date < time.getFullYear() + 50)
      return dates
    },
    month_items () {
      return [{text: '', value: null}, {text: 'January', value: 1}, {text: 'February', value: 2}, {text: 'March', value: 3}, {text: 'April', value: 4}, {text: 'May', value: 5}, {text: 'June', value: 6}, {text: 'July', value: 7}, {text: 'August', value: 8}, {text: 'September', value: 9}, {text: 'October', value: 10}, {text: 'November', value: 11}, {text: 'December', value: 12},]
    },
    day_items () {
      var max_days = this.max_days_in_month
      var days = [{text: '', value: null}]
      var day_int = 0
      do {
        day_int++
        days.push(day_int)
      }
      while (day_int < max_days)
      return days
    },
    leap_year_check () {
      return (this.value.year % 100 === 0) ? (this.value.year % 400 === 0) : (this.value.year % 4 === 0)
    },
    max_days_in_month () {
      switch (this.value.month) {
        case 4:
        case 6:
        case 9:
        case 11:
          return 30
        case 2:
          if (this.leap_year_check)
            return 29
          else
            return 28
        default:
          return 31
      }
    },
    highlightNoAnswer () {
      return (!this.value.year && this.formSubmissionAttempt && this.isRequired) || (this.formSubmissionAttempt && !this.valid)
    },
  }
}
</script>

<style>
.follow-up input {
  background-color: #ffffcc;
}
</style>
